import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProfileRepository from "../../../repository/ProfileRepository";
import { __remove, __set } from "../../axios_indicator";
import Constants from "src/helper/Constants";
const { shippingCarrierType: { MANUAL, AVNET } } = Constants

export const getProfileAccountInformation = createAsyncThunk('profile_getProfileAccountInformation', async () => {
    return await new ProfileRepository().getProfileAccountInformation()
});

export const getCountryList = createAsyncThunk('get_country_list', async () => {
    __set('PROFILE_ADDRESS_LIST');
    return await new ProfileRepository().getCountryList()
});

export const getJobFunctionList = createAsyncThunk('get_job_function_list', async () => {
    __set('PROFILE_JOB_FUNCTION_LIST');
    return await new ProfileRepository().getJobFunctionList()
});

export const fetchAllCarrierData = createAsyncThunk('fetch_all_carrier_data', async (params) => {
    if(params?.isOnlyAvnet) {
        return await new ProfileRepository().fetchCarrierData({ shippingCarrierType: AVNET, ...params?.params })
    } else if(params?.isOnlyManual) {
        return await new ProfileRepository().fetchCarrierData({ shippingCarrierType: MANUAL, ...params?.params })
    } else {
        return await Promise.all([
            new ProfileRepository().fetchCarrierData({ shippingCarrierType: MANUAL, ...params?.params }),
            new ProfileRepository().fetchCarrierData({ shippingCarrierType: AVNET, ...params?.params }),
        ]);
    }
});

const initialState = {
    accountInformation: {},
    countryList: [],
    userInformation: {},
    jobFunctionList: [],
    allCarriers: [],
    isCreditLineUser: false,
    carrierErrorMessage: ''
};
const slice = createSlice({
    name: "Profile",
    initialState: initialState,
    reducers: {},
    extraReducers: {
        [getProfileAccountInformation.fulfilled]: (state, { payload }) => {
            state.accountInformation = payload.data.accountInformation
            state.userInformation = payload.data.accountInformation?.user
            state.isCreditLineUser = payload.data.accountInformation?.user?.isCreditlineUser
            return state;
        },
        [getProfileAccountInformation.rejected]: (state, { payload }) => {
        },
        [getCountryList.fulfilled]: (state, { payload }) => {
            __remove('PROFILE_ADDRESS_LIST');
            state.countryList = payload;
        },
        [getJobFunctionList.fulfilled]: (state, { payload }) => {
            __remove('PROFILE_JOB_FUNCTION_LIST');
            state.jobFunctionList = payload;
        },
        [fetchAllCarrierData.fulfilled]: (state, { payload }) => {
            let combinedData;
            if (Array.isArray(payload)) {
                const [manualData, avnetData] = payload
                combinedData = {
                    ...manualData?.res,
                    fedEx: [...(manualData?.res.fedEx || []), ...(avnetData?.res.fedEx || [])],
                    dhl: [...(manualData?.res.dhl || []), ...(avnetData?.res.dhl || [])],
                    ups: [...(manualData?.res.ups || []), ...(avnetData?.res.ups || [])],
                    dom: [...(manualData?.res.dom || []), ...(avnetData?.res.dom || [])],
                    intl: [...(manualData?.res.intl || []), ...(avnetData?.res.intl || [])],
                    isIncoTerm: avnetData?.res.isIncoTerm || false,
                };
            } else {
                combinedData = {
                    ...payload?.res,
                    fedEx: [...(payload?.res.fedEx || [])],
                    dhl: [...(payload?.res.dhl || [])],
                    ups: [...(payload?.res.ups || [])],
                    dom: [...(payload?.res.dom || [])],
                    intl: [...(payload?.res.intl || [])],
                    isIncoTerm: payload?.res.isIncoTerm || false,
                    yamato_Transport: payload?.res.yamato_Transport || []
                };
            }
            state.allCarriers = combinedData;
            state.carrierErrorMessage = payload?.[0]?.errorMessage;
        },
    },
});

export let { setAllCarrierData } = slice.actions;

export default slice.reducer;
